import React from 'react';
import chunk from 'lodash-es/chunk';

import { Flex, Link } from '@rover/kibble/core';
import { FooterItem } from '@rover/rsdk/src/apiClient/latest';
import { getCookie } from '@rover/rsdk/src/modules/Network/cookies';
import { getSourceDescription } from '@rover/rsdk/src/modules/Network/userAgent';
import fireDataLayerEvent from '@rover/utilities/fireDataLayerEvent';

export const roverProtectUrl = '/rover-protect/';

export const renderFooterItemsAsChunk = (
  items: FooterItem[],
  chunkSize: number,
  additionalComponents: JSX.Element[] = []
): JSX.Element => {
  const platform = getSourceDescription();
  const cookieId = getCookie('rover_cid');
  const links = items.map((item) => (
    <Link
      href={item.url}
      key={item.name}
      mb="1x"
      variant="secondary"
      underline={false}
      size="100"
      onClick={() => {
        if (item.url === roverProtectUrl) {
          fireDataLayerEvent({
            event: 'roverprotect-footer-click',
            source: platform,
            personId: item.personOpk,
            cookieId,
          });
        }
      }}
      target={item.newTab ? '_blank' : '_self'}
      rel="noreferrer"
      sx={{ padding: '2px 0px' }}
    >
      {item.name}
    </Link>
  ));
  return chunk(links.concat(additionalComponents), chunkSize).map((linkChunk, index) => (
    <Flex flex="1" flexDirection="column" key={index}>
      {linkChunk}
    </Flex>
  ));
};
